import { render, staticRenderFns } from "./SeatsSelector.vue?vue&type=template&id=049b15d3&scoped=true"
import script from "./SeatsSelector.vue?vue&type=script&lang=js"
export * from "./SeatsSelector.vue?vue&type=script&lang=js"
import style0 from "./SeatsSelector.vue?vue&type=style&index=0&id=049b15d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b15d3",
  null
  
)

export default component.exports